import { render, staticRenderFns } from "./PhotoMedia.vue?vue&type=template&id=625e7324&scoped=true&"
import script from "./PhotoMedia.vue?vue&type=script&lang=js&"
export * from "./PhotoMedia.vue?vue&type=script&lang=js&"
import style0 from "./PhotoMedia.vue?vue&type=style&index=0&id=625e7324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e7324",
  null
  
)

export default component.exports